import WebModel from '../models/WebModel'

export namespace Usersync {
  export const init = (model: WebModel) => {
    if (window.$mediavine.web.usersyncInit) {
      window.$mediavine.web.usersyncInit(model)
    }
  }
}
